import React from 'react';
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Input, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { Btn, H5 } from '../../../AbstractElements';
import { SubmitForm, TermsText, classesfor, feedbackd, positionrelative, tooltipd, Tooltiptext, Tooltiptext2, Tooltiptext3, Tooltips } from '../../../Constant';
import { StateSelect } from '../../../Data/Ecommerce/ProductPage';

import InputControl from '../../Common/FormInputs/InputControl';

const TooltipForm = () => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const formSubmitHandler = () => {
    reset();
  };
  return (
    <Card>
      <CardHeader className='pb-0'>
        <H5>{Tooltips}</H5>
        <span>
          {Tooltiptext} <code className='text-danger'>{feedbackd}</code> {classesfor} <code className='text-danger'>{tooltipd}</code> {Tooltiptext2} <code className='text-danger'>{positionrelative}</code> {Tooltiptext3}
        </span>
      </CardHeader>
      <CardBody>
        <Form className='needs-validation' noValidate='' onSubmit={handleSubmit(formSubmitHandler)}>
          <Row className='g-3'>
            <Col md='4'>
              <InputControl tooltip={true} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter First Name *' register={{ ...register('first_name', { required: 'is Required.' }) }} />
            </Col>
            <Col md='4'>
              <InputControl tooltip={true} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter Last Name *' register={{ ...register('last_name', { required: 'is Required.' }) }} />
            </Col>
            <Col md='4 mb-3'>
              <InputControl tooltip={true} pereFix='@' controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter Last Name *' register={{ ...register('user_name', { required: 'is Required.' }) }} />
            </Col>
          </Row>
          <Row className='g-3'>
            <Col md='6'>
              <InputControl tooltip={true} controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter City Name *' register={{ ...register('city', { required: 'is Required.' }) }} />
            </Col>
            <Col md='3'>
              <InputControl tooltip={true} control={control} placeholder='select...' controlInput='select' options={StateSelect} className='form-select' errors={errors} register={{ ...register('state', { required: 'is Required.' }) }} />
            </Col>
            <Col md='3' className='mb-3'>
              <InputControl tooltip={true} controlInput='input' className='form-control' type='number' errors={errors} placeholder='Enter Zip Code *' register={{ ...register('zip', { required: 'is Required.', minLength: '6', maxLength: '6' }) }} />
            </Col>
          </Row>
          <FormGroup>
            <div className='form-check'>
              <div className='checkbox p-0'>
                <Input className='form-check-input' id='invalidCheck' type='checkbox' />
                <Label className='form-check-label' htmlFor='invalidCheck'>
                  {TermsText}
                </Label>
              </div>
            </div>
          </FormGroup>
          <Btn color='primary'>{SubmitForm}</Btn>
        </Form>
      </CardBody>
    </Card>
  );
};

export default TooltipForm;
